const fr = {
  // Navigation
  "nav": {
    "home": "Accueil",
    "approach": "Notre approche",
    "offers": "Nos offres",
    "segments": "Segments clients",
    "calculator": "Calculateur carbone",
    "blog": "Blog",
    "about": "À propos",
    "contact": "Contact"
  },
  
  // Common elements
  "common": {
    "learn_more": "En savoir plus",
    "contact_us": "Contactez-nous",
    "read_more": "Lire la suite"
  },
  
  // Home page
  "home": {
    "hero": {
      "title": "Solutions de décarbonation adaptées à votre contexte",
      "subtitle": "Nous vous accompagnons dans votre transition écologique avec des solutions sur mesure",
      "cta": "Découvrir nos offres"
    },
    "models": {
      "title": "Des modèles économiques innovants",
      "subtitle": "Choisissez la formule qui correspond le mieux à vos besoins",
      "classic": {
        "title": "Abonnement Classique",
        "description": "Accès complet à notre plateforme avec un abonnement mensuel ou annuel"
      },
      "performance": {
        "title": "Performance Carbone",
        "description": "Paiement basé sur les réductions d'émissions carbone réellement atteintes"
      },
      "shared": {
        "title": "Valeur Partagée",
        "description": "Partage des économies financières générées par la réduction de votre empreinte"
      },
      "knowledge": {
        "title": "Contribution Connaissance",
        "description": "Accès gratuit en échange de données anonymisées pour enrichir notre base de connaissances"
      }
    },
    "benefits": {
      "title": "Pourquoi choisir mypa ?",
      "adapted": {
        "title": "Solutions adaptées",
        "description": "Des approches sur mesure pour répondre à vos enjeux spécifiques"
      },
      "innovative": {
        "title": "Modèles innovants",
        "description": "Des formules flexibles alignées avec vos objectifs"
      },
      "expertise": {
        "title": "Expertise reconnue",
        "description": "Une équipe de spécialistes des enjeux carbone"
      }
    }
  },
  
  // Approach page
  "approach": {
    "title": "Notre approche",
    "subtitle": "Une méthodologie adaptée à votre contexte",
    "methodology": {
      "title": "Méthodologie",
      "description": "Notre approche combine expertise technique, connaissance du terrain et innovation pour vous proposer des solutions vraiment adaptées à votre réalité."
    },
    "steps": {
      "title": "Notre processus",
      "diagnostic": {
        "title": "Diagnostic",
        "description": "Analyse complète de votre situation actuelle et de vos enjeux spécifiques"
      },
      "strategy": {
        "title": "Stratégie",
        "description": "Élaboration d'une feuille de route personnalisée avec objectifs et indicateurs"
      },
      "implementation": {
        "title": "Mise en œuvre",
        "description": "Accompagnement dans le déploiement des actions et solutions"
      },
      "monitoring": {
        "title": "Suivi",
        "description": "Mesure continue des résultats et ajustements pour optimiser l'impact"
      }
    }
  },
  
  // Offers page
  "offers": {
    "title": "Nos offres",
    "subtitle": "Des solutions adaptées à chaque étape de votre parcours",
    "discovery": {
      "title": "Découverte",
      "description": "Premier pas vers la décarbonation avec un diagnostic initial et des recommandations",
      "features": [
        "Bilan carbone simplifié",
        "Identification des opportunités",
        "Recommandations prioritaires",
        "Accès limité à la plateforme"
      ]
    },
    "performance": {
      "title": "Performance",
      "description": "Accompagnement complet pour réduire significativement votre empreinte",
      "features": [
        "Bilan carbone détaillé",
        "Plan d'action personnalisé",
        "Accompagnement à la mise en œuvre",
        "Accès complet à la plateforme",
        "Suivi trimestriel des indicateurs"
      ]
    },
    "strategy": {
      "title": "Stratégie",
      "description": "Transformation profonde de votre organisation vers un modèle bas carbone",
      "features": [
        "Stratégie carbone intégrée",
        "Accompagnement dirigeants",
        "Formation des équipes",
        "Intégration dans la stratégie d'entreprise",
        "Reporting et communication",
        "Accès premium à la plateforme"
      ]
    }
  },
  
  // Segments page
  "segments": {
    "title": "Segments clients",
    "subtitle": "Des solutions adaptées à votre profil",
    "intro": {
      "title": "Segmentation client personnalisée",
      "description": "Nous avons identifié différents profils d'organisations avec des besoins spécifiques en matière de décarbonation.",
      "point1": "Chaque organisation fait face à des défis différents",
      "point2": "Les réglementations varient selon les secteurs et la taille",
      "point3": "Les ressources disponibles ne sont pas les mêmes",
      "point4": "Les motivations et objectifs peuvent différer"
    },
    "solutions": {
      "title": "Nos solutions par segment"
    },
    "exporters": {
      "title": "Exportateurs",
      "description": "Solutions pour les entreprises exportatrices confrontées aux nouvelles réglementations",
      "point1": "Secteurs concernés : acier, aluminium, ciment, engrais, électricité, hydrogène",
      "point2": "Enjeu : conformité réglementaire et compétitivité",
      "solution": {
        "title": "Notre solution pour les exportateurs",
        "description": "Notre accompagnement spécifique pour les exportateurs vous aide à naviguer dans la complexité du CBAM (Carbon Border Adjustment Mechanism) et à maintenir votre compétitivité sur le marché européen.",
        "feature1": {
          "title": "Conformité CBAM",
          "description": "Préparation aux déclarations d'émissions et vérification par des organismes agréés"
        },
        "feature2": {
          "title": "Optimisation des coûts",
          "description": "Stratégies de réduction des émissions pour minimiser l'impact financier du CBAM"
        },
        "feature3": {
          "title": "Veille réglementaire",
          "description": "Suivi des évolutions du CBAM et anticipation des impacts"
        },
        "feature4": {
          "title": "Différenciation produit",
          "description": "Valorisation de votre démarche bas-carbone auprès de vos clients européens"
        }
      },
      "recommendation": {
        "title": "Notre recommandation",
        "description": "Bilan carbone complet + modèle Performance Carbone",
        "details": "Idéal pour les entreprises concernées par le CBAM et souhaitant sécuriser leur accès au marché européen."
      }
    },
    "large": {
      "title": "Grandes Entreprises",
      "description": "Accompagnement stratégique pour les organisations avec des enjeux ESG complexes",
      "point1": "Enjeux : reporting, stratégie climat, engagement des parties prenantes",
      "point2": "Besoin d'une approche structurée et complète",
      "solution": {
        "title": "Notre solution pour les grandes entreprises",
        "description": "Notre accompagnement pour les grandes entreprises vous permet de structurer et d'optimiser votre démarche ESG, avec un focus particulier sur le volet environnemental et la réduction de votre empreinte carbone.",
        "feature1": {
          "title": "Reporting extra-financier",
          "description": "Préparation aux exigences CSRD, TCFD et autres cadres de reporting"
        },
        "feature2": {
          "title": "Stratégie climat",
          "description": "Définition d'objectifs SBTi et trajectoire de décarbonation"
        },
        "feature3": {
          "title": "Scope 3 & chaîne de valeur",
          "description": "Évaluation et réduction des émissions indirectes"
        },
        "feature4": {
          "title": "Engagement des parties prenantes",
          "description": "Mobilisation des collaborateurs, fournisseurs et clients"
        }
      },
      "recommendation": {
        "title": "Notre recommandation",
        "description": "Offre Stratégie + modèle Valeur Partagée",
        "details": "Parfait pour les entreprises ayant des objectifs ambitieux et souhaitant intégrer la décarbonation dans leur stratégie globale."
      }
    },
    "sme": {
      "title": "PME Engagées",
      "description": "Solutions accessibles pour les PME souhaitant s'engager dans une démarche durable",
      "point1": "Motivations : valeurs, attentes clients, attractivité employeur",
      "point2": "Besoin d'une approche pragmatique et progressive",
      "solution": {
        "title": "Notre solution pour les PME engagées",
        "description": "Notre accompagnement pour les PME engagées vous propose une approche pragmatique et progressive, adaptée à vos ressources et à votre niveau de maturité.",
        "feature1": {
          "title": "Diagnostic initial",
          "description": "Évaluation de votre empreinte carbone et identification des priorités"
        },
        "feature2": {
          "title": "Plan d'action ciblé",
          "description": "Focalisation sur les actions à fort impact et retour sur investissement"
        },
        "feature3": {
          "title": "Valorisation de la démarche",
          "description": "Communication adaptée auprès de vos clients et collaborateurs"
        },
        "feature4": {
          "title": "Montée en compétences",
          "description": "Formation de vos équipes aux enjeux climat et aux bonnes pratiques"
        }
      },
      "recommendation": {
        "title": "Notre recommandation",
        "description": "Offre Performance + modèle Abonnement Classique",
        "details": "Adapté aux entreprises ayant des ressources limitées mais souhaitant structurer leur démarche environnementale."
      }
    },
    "vsmall": {
      "title": "TPE/PME",
      "description": "Approches simplifiées et abordables pour les plus petites structures",
      "point1": "Contraintes : ressources limitées, peu de temps disponible",
      "point2": "Besoin d'une approche simple et accessible",
      "solution": {
        "title": "Notre solution pour les TPE/PME",
        "description": "Notre accompagnement pour les TPE/PME vous propose une approche simplifiée et accessible, avec des actions concrètes et faciles à mettre en œuvre malgré des ressources limitées.",
        "feature1": {
          "title": "Auto-diagnostic guidé",
          "description": "Outils simples pour évaluer vos principaux impacts environnementaux"
        },
        "feature2": {
          "title": "Actions \"quick wins\"",
          "description": "Identification des actions simples à fort impact et faible coût"
        },
        "feature3": {
          "title": "Ressources en ligne",
          "description": "Accès à des guides pratiques et modèles de documents"
        },
        "feature4": {
          "title": "Communauté d'entraide",
          "description": "Échanges avec d'autres TPE/PME engagées dans la même démarche"
        }
      },
      "recommendation": {
        "title": "Notre recommandation",
        "description": "Offre Découverte + modèle Contribution Connaissance",
        "details": "Idéal pour les petites structures souhaitant initier une démarche environnementale sans investissement important."
      }
    },
    "testimonials": {
      "title": "Ils nous font confiance",
      "testimonial1": {
        "name": "Ahmed K.",
        "role": "Directeur Développement Durable, Entreprise d'exportation",
        "quote": "L'accompagnement de mypa nous a permis de nous préparer efficacement aux exigences du CBAM. Nous avons non seulement sécurisé notre accès au marché européen, mais aussi identifié des opportunités d'optimisation de nos processus."
      },
      "testimonial2": {
        "name": "Sophie M.",
        "role": "Responsable RSE, PME engagée",
        "quote": "Avec mypa, nous avons pu structurer notre démarche environnementale de manière pragmatique et progressive. Les outils et l'accompagnement proposés sont parfaitement adaptés à notre taille et à nos ressources."
      }
    },
    "cta": {
      "title": "Prêt à démarrer votre démarche de décarbonation ?",
      "description": "Contactez-nous pour discuter de vos besoins spécifiques et découvrir comment nous pouvons vous accompagner.",
      "button": "Nous contacter"
    },
    "learn_more": "En savoir plus"
  },
  
  // Calculator page
  "calculator": {
    "title": "Calculateur d'empreinte carbone",
    "subtitle": "Estimez votre impact environnemental personnel",
    "intro": "Répondez à quelques questions simples pour obtenir une estimation de votre empreinte carbone personnelle et des recommandations adaptées.",
    "select": "Sélectionnez une option",
    "next": "Suivant",
    "previous": "Précédent",
    "calculate": "Calculer mon empreinte",
    "steps": {
      "housing": "Logement",
      "transport": "Transport",
      "food": "Alimentation",
      "consumption": "Consommation",
      "results": "Résultats"
    },
    "housing": {
      "title": "Votre logement",
      "size": "Quelle est la taille de votre logement ?",
      "size_small": "Petit (< 50 m²)",
      "size_medium": "Moyen (50-100 m²)",
      "size_large": "Grand (> 100 m²)",
      "type": "Quel type de logement occupez-vous ?",
      "type_apartment": "Appartement",
      "type_house": "Maison individuelle",
      "energy": "Quel est le montant approximatif de votre facture d'électricité mensuelle ?",
      "energy_low": "Faible (< 50€)",
      "energy_medium": "Moyen (50-100€)",
      "energy_high": "Élevé (> 100€)",
      "heating": "Quel type de chauffage utilisez-vous principalement ?",
      "heating_electric": "Électrique",
      "heating_gas": "Gaz",
      "heating_oil": "Fioul",
      "heating_renewable": "Énergies renouvelables"
    },
    "transport": {
      "title": "Vos déplacements",
      "car": "Combien de kilomètres parcourez-vous en voiture par mois environ ?",
      "car_none": "Pas de voiture",
      "car_low": "Peu (< 500 km)",
      "car_medium": "Moyen (500-1000 km)",
      "car_high": "Beaucoup (> 1000 km)",
      "fuel": "Quel type de carburant utilise votre véhicule principal ?",
      "fuel_gasoline": "Essence",
      "fuel_diesel": "Diesel",
      "fuel_hybrid": "Hybride",
      "fuel_electric": "Électrique",
      "public": "À quelle fréquence utilisez-vous les transports en commun ?",
      "public_never": "Jamais",
      "public_sometimes": "Occasionnellement",
      "public_often": "Régulièrement",
      "plane": "Combien de vols prenez-vous par an en moyenne ?",
      "plane_none": "Aucun",
      "plane_few": "1-2 vols",
      "plane_many": "3 vols ou plus"
    },
    "food": {
      "title": "Votre alimentation",
      "diet": "Quel régime alimentaire suivez-vous principalement ?",
      "diet_vegan": "Végétalien",
      "diet_vegetarian": "Végétarien",
      "diet_flexitarian": "Flexitarien",
      "diet_meat": "Viande quotidienne",
      "local": "À quelle fréquence consommez-vous des produits locaux et de saison ?",
      "local_always": "Toujours",
      "local_sometimes": "Parfois",
      "local_rarely": "Rarement",
      "waste": "Quelle quantité de nourriture estimez-vous jeter chaque semaine ?",
      "waste_none": "Presque rien",
      "waste_little": "Un peu",
      "waste_much": "Beaucoup"
    },
    "consumption": {
      "title": "Votre consommation",
      "shopping": "À quelle fréquence achetez-vous de nouveaux vêtements ?",
      "shopping_rarely": "Rarement",
      "shopping_sometimes": "Occasionnellement",
      "shopping_often": "Souvent",
      "electronic": "À quelle fréquence renouvelez-vous vos appareils électroniques ?",
      "electronic_rarely": "Rarement (> 5 ans)",
      "electronic_sometimes": "Occasionnellement (3-5 ans)",
      "electronic_often": "Souvent (< 3 ans)",
      "recycling": "Triez-vous vos déchets ?",
      "recycling_always": "Toujours",
      "recycling_sometimes": "Parfois",
      "recycling_never": "Jamais"
    },
    "results": {
      "title": "Vos résultats",
      "footprint": "Votre empreinte carbone est estimée à",
      "average": "La moyenne nationale est de",
      "breakdown": "Répartition de votre empreinte",
      "recommendations": "Recommandations personnalisées"
    },
    "recommendations": {
      "heating_change": "Envisagez de passer à un système de chauffage plus écologique",
      "reduce_electricity": "Réduisez votre consommation d'électricité en optant pour des appareils plus efficaces",
      "reduce_car": "Limitez vos déplacements en voiture et privilégiez les alternatives",
      "limit_flights": "Réduisez le nombre de vols que vous prenez chaque année",
      "use_public_transport": "Utilisez davantage les transports en commun",
      "reduce_meat": "Réduisez votre consommation de viande",
      "local_food": "Privilégiez les produits locaux et de saison",
      "reduce_waste": "Réduisez le gaspillage alimentaire",
      "responsible_consumption": "Adoptez une consommation plus responsable",
      "extend_electronics": "Prolongez la durée de vie de vos appareils électroniques",
      "start_recycling": "Commencez à trier vos déchets",
      "continue_efforts": "Continuez vos efforts, vous êtes sur la bonne voie !",
      "join_initiatives": "Rejoignez des initiatives locales pour amplifier votre impact"
    }
  },
  
  // Blog page
  "blog": {
    "title": "Blog",
    "description": "Actualités, analyses et conseils sur la décarbonation",
    "categories": {
      "all": "Tous les articles",
      "regulation": "Réglementation",
      "strategy": "Stratégie",
      "financing": "Financement",
      "case_study": "Études de cas",
      "innovation": "Innovation",
      "market": "Marché"
    },
    "read_more": "Lire la suite",
    "search": "Rechercher un article",
    "recent_posts": "Articles récents",
    "popular_tags": "Tags populaires",
    "newsletter": {
      "title": "Abonnez-vous à notre newsletter",
      "description": "Recevez nos derniers articles et actualités directement dans votre boîte mail",
      "placeholder": "Votre adresse email",
      "button": "S'abonner"
    },
    "posts": {
      "cbam": {
        "title": "Impact du CBAM sur les entreprises exportatrices",
        "summary": "Analyse des conséquences du mécanisme d'ajustement carbone aux frontières pour les exportateurs",
        "content": {
          "p1": "Le mécanisme d'ajustement carbone aux frontières (CBAM) représente un changement majeur pour les entreprises exportatrices. Cette nouvelle réglementation européenne vise à égaliser les conditions de concurrence entre les producteurs de l'UE soumis à des politiques climatiques strictes et les importateurs de pays tiers où ces contraintes sont moins fortes.",
          "p2": "Pour les entreprises exportatrices, le CBAM implique de nouvelles obligations de reporting et potentiellement des coûts supplémentaires. Les secteurs les plus concernés sont l'acier, l'aluminium, le ciment, les engrais et l'électricité, mais d'autres secteurs pourraient être inclus à l'avenir.",
          "p3": "La préparation au CBAM nécessite une compréhension approfondie de l'empreinte carbone de vos produits et de votre chaîne d'approvisionnement. Les entreprises doivent mettre en place des systèmes de mesure et de reporting fiables pour quantifier leurs émissions de gaz à effet de serre.",
          "p4": "Au-delà de la conformité, le CBAM peut également représenter une opportunité pour les entreprises qui ont déjà investi dans des processus de production bas carbone. Ces entreprises pourront bénéficier d'un avantage concurrentiel sur les marchés européens par rapport aux concurrents moins avancés dans leur transition écologique.",
          "p5": "Mypa propose un accompagnement spécifique pour les entreprises concernées par le CBAM, incluant l'évaluation de l'impact réglementaire, la mise en place de systèmes de mesure conformes, et le développement de stratégies d'adaptation."
        }
      },
      "strategies": {
        "title": "Stratégies de décarbonation efficaces pour les PME",
        "summary": "Guide pratique pour mettre en œuvre des actions de réduction d'empreinte carbone adaptées aux PME",
        "content": {
          "p1": "La décarbonation représente un défi particulier pour les PME, qui disposent souvent de ressources limitées mais font face aux mêmes enjeux environnementaux que les grandes entreprises. Pourtant, leur agilité peut constituer un atout majeur dans cette transition.",
          "p2": "La première étape consiste à réaliser un bilan carbone simplifié pour identifier les principales sources d'émissions. Pour la plupart des PME, celles-ci se concentrent généralement sur la consommation d'énergie des bâtiments, les déplacements professionnels et la logistique.",
          "p3": "Des actions à gain rapide peuvent être mises en place rapidement : optimisation énergétique des locaux, politique de mobilité durable, réduction des déchets, ou encore sensibilisation des équipes aux écogestes. Ces mesures permettent souvent de réaliser des économies financières tout en réduisant l'empreinte carbone.",
          "p4": "Pour aller plus loin, les PME peuvent envisager des investissements plus structurants : rénovation énergétique des bâtiments, installation de panneaux solaires, renouvellement de la flotte de véhicules vers des modèles électriques, ou encore refonte des processus de production pour réduire les intrants et les déchets.",
          "p5": "L'engagement des collaborateurs est un facteur clé de succès. En impliquant les équipes dans la démarche et en valorisant les initiatives individuelles, les PME peuvent créer une dynamique positive autour de leur stratégie de décarbonation."
        }
      },
      "financing": {
        "title": "Financement des projets climat : opportunités et mécanismes",
        "summary": "Panorama des solutions de financement disponibles pour les projets de décarbonation",
        "content": {
          "p1": "Le financement constitue souvent un frein majeur à la mise en œuvre de projets de décarbonation ambitieux. Pourtant, de nombreux mécanismes existent pour soutenir les entreprises dans cette transition, qu'il s'agisse d'aides publiques, de financements privés ou de solutions innovantes.",
          "p2": "Les aides publiques se déclinent à différents niveaux : subventions nationales pour la transition écologique, programmes régionaux de soutien à l'innovation verte, ou encore financements européens comme le Fonds pour l'innovation ou le programme LIFE. Ces dispositifs peuvent couvrir une partie significative des investissements initiaux.",
          "p3": "Du côté des financements privés, on observe une multiplication des offres bancaires dédiées à la transition écologique, avec des taux préférentiels pour les projets à impact positif. Les fonds d'investissement spécialisés dans la finance climat représentent également une source de financement en plein essor.",
          "p4": "Des mécanismes innovants émergent également, comme les contrats de performance énergétique, où le prestataire est rémunéré sur la base des économies réalisées, ou encore le crowdfunding vert, qui permet de mobiliser l'épargne citoyenne au service de projets écologiques.",
          "p5": "Enfin, la valorisation des réductions d'émissions carbone, via les marchés volontaires ou réglementés, peut constituer une source de revenus complémentaire pour certains projets. Cette approche permet de monétiser les bénéfices environnementaux et d'améliorer ainsi la rentabilité des investissements bas carbone."
        }
      }
    }
  },
  
  // Footer
  "footer": {
    "company": "Entreprise",
    "about": "À propos",
    "careers": "Carrières",
    "contact": "Contact",
    "legal": "Mentions légales",
    "privacy": "Politique de confidentialité",
    "terms": "Conditions d'utilisation",
    "cookies": "Gestion des cookies",
    "newsletter": {
      "title": "Restez informé",
      "description": "Inscrivez-vous à notre newsletter pour recevoir nos dernières actualités",
      "placeholder": "Votre email",
      "button": "S'inscrire"
    },
    "copyright": "© 2025 mypa.earth. Tous droits réservés.",
    "social": "Suivez-nous"
  },
  
  // Contact page
  "contact": {
    "title": "Contactez-nous",
    "subtitle": "Nous sommes là pour répondre à vos questions",
    "form": {
      "name": "Nom",
      "email": "Email",
      "company": "Entreprise",
      "subject": "Sujet",
      "message": "Message",
      "submit": "Envoyer",
      "success": "Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.",
      "error": "Une erreur est survenue. Veuillez réessayer."
    },
    "info": {
      "title": "Informations de contact",
      "email": "Email",
      "phone": "Téléphone",
      "address": "Adresse"
    },
    "faq": {
      "title": "Questions fréquentes",
      "q1": "Comment débuter une démarche de décarbonation ?",
      "a1": "La première étape consiste à réaliser un bilan carbone pour identifier vos principales sources d'émissions. Nous proposons un accompagnement adapté à votre niveau de maturité.",
      "q2": "Quels sont vos tarifs ?",
      "a2": "Nos tarifs varient selon le modèle économique choisi et le niveau d'accompagnement. Contactez-nous pour obtenir un devis personnalisé.",
      "q3": "Combien de temps faut-il pour voir des résultats ?",
      "a3": "Les premiers résultats sont généralement visibles dans les 3 à 6 mois suivant le démarrage de la démarche, avec des actions à gain rapide. La transformation complète s'inscrit sur plusieurs années.",
      "q4": "Travaillez-vous avec des entreprises de toutes tailles ?",
      "a4": "Oui, nous avons développé des offres adaptées à chaque profil d'organisation, des TPE aux grandes entreprises."
    }
  },
  
  // About page
  "about": {
    "title": "À propos de mypa",
    "subtitle": "Manifest Your Planet Action",
    "mission": {
      "title": "Notre mission",
      "description": "Rendre la décarbonation accessible à toutes les organisations, quelle que soit leur taille ou leur secteur d'activité, en proposant des solutions adaptées à leur contexte et à leurs ressources."
    },
    "vision": {
      "title": "Notre vision",
      "description": "Un monde où chaque organisation contribue activement à la lutte contre le changement climatique, en intégrant la décarbonation dans sa stratégie et ses opérations."
    },
    "values": {
      "title": "Nos valeurs",
      "innovation": {
        "title": "Innovation",
        "description": "Nous développons constamment de nouvelles approches pour rendre la décarbonation plus accessible et efficace."
      },
      "impact": {
        "title": "Impact",
        "description": "Nous mesurons notre succès à l'aune des réductions d'émissions que nous permettons à nos clients de réaliser."
      },
      "inclusion": {
        "title": "Inclusion",
        "description": "Nous croyons que la transition écologique doit être inclusive et bénéficier à tous."
      },
      "integrity": {
        "title": "Intégrité",
        "description": "Nous agissons avec transparence et honnêteté dans toutes nos interactions."
      }
    },
    "team": {
      "title": "Notre équipe",
      "description": "Une équipe pluridisciplinaire d'experts passionnés par la transition écologique.",
      "members": {
        "member1": {
          "name": "Sarah Benali",
          "role": "Fondatrice & CEO",
          "bio": "Ingénieure de formation avec 15 ans d'expérience dans le conseil en développement durable."
        },
        "member2": {
          "name": "Thomas Dubois",
          "role": "Directeur Technique",
          "bio": "Expert en systèmes d'information et en analyse de données environnementales."
        },
        "member3": {
          "name": "Aïcha Koné",
          "role": "Responsable Clients",
          "bio": "Spécialiste de l'accompagnement des organisations dans leur transition écologique."
        }
      }
    },
    "partners": {
      "title": "Nos partenaires",
      "description": "Nous collaborons avec un réseau de partenaires pour offrir des solutions complètes à nos clients."
    }
  },
  
  // 404 page
  "notFound": {
    "title": "Page non trouvée",
    "description": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "button": "Retour à l'accueil"
  }
};

export default fr;
